import { IPOption } from '../types/ip';

export function generateIPLabel(name: string) {
  return function (this: IPOption): string {
    return `${name} (/${this.subnet} subnet)`;
  };
}
